import React, {Component} from 'react';
import Utils, {arrayToDataTable} from "../../config/Utils";
import countries from "../../../assets/country_codes";
import Autocomplete from "react-autocomplete";
import * as actions from "../../store/actions";
import connect from "react-redux/es/connect/connect";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import countryFlag from "../../../assets/countryFlag";
import {FlagComponent} from "../../v2/components/countryFlag/flag";
import {ChartCardComponent} from "../../v2/components/chartCards/chartCard";
import {CountryStatisticsSidebarComponent} from "../../v2/components/sidebars/countryStatisticsSidebarComponent";
import Aux from 'react-aux'

class CompareCountries extends Component {

    state = {
        countryCode: "",
        compareToCountry: "",
        opponentImageName: 'unknown.png'
    };

    componentDidMount() {
        const queryParams = Utils.decodeQueryString(this.props.location.search);
        let countryCode = queryParams['countryCode'];
        if (!countryCode) {
            this.props.history.goBack();
        }
        this.props.loadCountries();
        this.props.getStatisticsForCountry(countryCode);
        this.setState({countryCode});
    };

    onInputChange = e => {
        this.setState({compareToCountry: e.target.value});
        if (e.target.value.length === 0) {
            this.props.clearSelection();
        }
    };

    onSelect = val => {
        let opponentCode = Object.keys(countries)
            .find(it => countries[it].toLowerCase() === val.toLowerCase());
        this.setState({
            compareToCountry: countries[opponentCode],
            opponentImageName: countryFlag[opponentCode.toUpperCase()]
        });
        if (val.length === 0) {
            this.props.clearSelection();
        }
        this.props.getStatisticsForOpponentCountry(opponentCode);
    };

    renderItem = (item, isHighlighted) => {
        let displayName = item;
        if (item && item.length > 35) {
            displayName = item.substr(0, 35) + "...";
        }
        return (
            <button key={item} className={'dropdown-item w-100'}
               style={{background: isHighlighted ? 'lightgray' : 'white', color: "black"}}>
                {displayName}
            </button>
        )
    };

    getCountries = () => {
        if (!this.props.countries) return [];
        return this.props.countries
            .filter(key => key !== this.state.countryCode)
            .map(ct => countries[ct])
    };

    prepDataForCountry = (isFirstCountry) => {
        let source;
        if (isFirstCountry)
            source = this.props.countryStatistics
        else
            source = this.props.opponentCountryStatistics

        if (!source) return null;

        let stats = source.anatomicalGroupsCount.map(item => [item.countryCode, item.count]);
        stats.unshift(['ATC', 'Drugs count']);

        let manufacturersData = source.drugsCountPerManufacturer.slice(0, 5).map(item => [item.countryCode, item.count]);
        manufacturersData.unshift(['Manufacturer', 'Drugs count']);

        return [stats, manufacturersData]
    }

    renderCompanyStatistics = (isFirstCountry) => {
        let sourceStat, sourceMan, temp;
        temp = this.prepDataForCountry(isFirstCountry)
        if (!temp) return null;
        sourceStat = temp[0]
        sourceMan = temp[1]
        return (
            <div className={'col-6'}>
                <ChartCardComponent
                    title={'ATC Coverage'}
                    subtitle={isFirstCountry ? countries[this.state.countryCode.toUpperCase()] : this.state.compareToCountry}
                    height={'350px'}
                    chartType={'PieChart'}
                    data={sourceStat}
                />
                <ChartCardComponent
                    title={'Top 5 Manufacturers'}
                    subtitle={isFirstCountry ? countries[this.state.countryCode.toUpperCase()] : this.state.compareToCountry}
                    height={'350px'}
                    chartType={'PieChart'}
                    data={sourceMan}
                />
            </div>
        )
    };

    renderPanels = () => {
        if (!this.props.opponentCountryStatistics || !this.props.companyStatistics) return null
        return (
            <div className={'row'}>
                <div className="col-6">
                    <CountryStatisticsSidebarComponent
                        image={countryFlag[this.state.countryCode.toUpperCase()]}
                        country={countries[this.state.countryCode]}
                        drugsCount={this.props.countryStatistics.drugsCount}
                        numberOfManufacturers={this.props.countryStatistics.numberOfManufacturers}
                        manufacturers={arrayToDataTable(this.props.countryStatistics.drugsCountPerManufacturer, ['Manufacturer', 'Drugs count'])}
                    />
                </div>
                <div className="col-6">
                    <CountryStatisticsSidebarComponent
                        image={this.state.opponentImageName}
                        country={this.state.compareToCountry}
                        drugsCount={this.props.opponentCountryStatistics.drugsCount}
                        numberOfManufacturers={this.props.opponentCountryStatistics.numberOfManufacturers}
                        manufacturers={arrayToDataTable(this.props.opponentCountryStatistics.drugsCountPerManufacturer, ['Manufacturer', 'Drugs count'])}
                    />
                </div>
            </div>
        )
    }

    renderCombinedChart = () => {
        const countryStatistics = this.props.countryStatistics;
        const opponentCountryStatistics = this.props.opponentCountryStatistics;
        if (!countryStatistics || !opponentCountryStatistics) return null;

        let data = [["Drugs count", countries[this.state.countryCode], this.state.compareToCountry]];
        let todayYear = new Date().getFullYear();
        for (let i = todayYear - 10; i <= todayYear; i++) {
            const a = countryStatistics.drugsPerLicenceValidFromYear.filter(it => it.countryCode === i.toString())[0] || 0;
            const b = opponentCountryStatistics.drugsPerLicenceValidFromYear.filter(it => it.countryCode === i.toString())[0] || 0;
            data.push([i.toString(), a.count, b.count])
        }
        return (
            <div className={'col-6 mx-auto'}>
                <ChartCardComponent
                    title={'Total drugs by year'}
                    subtitle={'Based on produced drugs in the last 10 year'}
                    height={'400px'}
                    chartType={'Bar'}
                    data={data}
                />
            </div>
        )
    };

    renderCombinedATCChart = () => {
        const countryStatistics = this.props.countryStatistics;
        const opponentCountryStatistics = this.props.opponentCountryStatistics;
        if (!countryStatistics || !opponentCountryStatistics) return null;
        let atcCount = {};
        if (countryStatistics.anatomicalGroupsCount.length === 0 || opponentCountryStatistics.anatomicalGroupsCount.length === 0) return null;
        countryStatistics.anatomicalGroupsCount.forEach(item => {
            atcCount[item.countryCode] = {"home_company": item.count}
        });
        opponentCountryStatistics.anatomicalGroupsCount.forEach(item => {
            if (!atcCount[item.countryCode]) {
                atcCount[item.count] = {};
            }
            atcCount[item.countryCode]["opponent_company"] = item.count;
        });
        let data = [];
        data.push(["ATC Group", countries[this.state.countryCode], this.state.compareToCountry]);
        Object.keys(atcCount).forEach(key => {
            const opponent = atcCount[key]["opponent_company"] || 0;
            const home = atcCount[key]["home_company"] || 0;
            data.push([key, home, opponent]);
        });
        return (
            <div className={'col-6 mx-auto'}>
                <ChartCardComponent
                    title={'Total drugs by year by ATC group'}
                    subtitle={''}
                    height={'400px'}
                    chartType={'Bar'}
                    data={data}
                />
            </div>
        )
    };

    renderMessage = () => {
        if (!this.props.opponentCountryStatistics) {
            return (
                <div className={'col text-center text-secondary d-flex align-items-center justify-content-center'}
                     style={{minHeight: 70 + 'vh'}}>
                    <h2 className={'my-auto'}>Please select an opponent country</h2>
                </div>
            )
        } else return null;
    };

    renderHeader = () => {
        let imageName = countryFlag[this.state.countryCode.toUpperCase()];
        return (
            <div className={'card-header bg-success text-light d-flex justify-items-around mb-3'}>
                <div className={'d-flex align-items-center'}>
                    <FlagComponent imageName={imageName}/>
                    <h2 className={'m-0 ml-2 font-weight-bold'}>{countries[this.state.countryCode]}</h2>
                </div>
                <div className={'d-flex align-items-center ml-auto'}>
                    <div className={'position-relative text-dark'}>
                        <Autocomplete
                            getItemValue={(item) => item}
                            items={this.getCountries()}
                            renderItem={this.renderItem}
                            value={this.state.compareToCountry}
                            onChange={this.onInputChange}
                            onSelect={this.onSelect}
                            inputProps={{className: 'form-control'}}
                            menuStyle={{
                                height: "100%",
                                zIndex: 100,
                                position: 'absolute',
                                top: "100%",
                                left: 0
                            }}
                        />
                    </div>
                    <div className={'ml-2'}>
                        <FlagComponent imageName={this.state.opponentImageName}/>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        if (!this.state.countryCode || this.state.countryCode.length === 0)
            return <CircularProgress/>;
        else if (this.state.compareToCountry) {
            return (
                <Aux>
                    {this.renderHeader()}
                    {this.renderPanels()}
                    <div className="row">
                        {this.renderCompanyStatistics(true)}
                        {this.renderCompanyStatistics(false)}
                    </div>
                    <div className={'row'}>
                        {this.renderCombinedChart()}
                        {this.renderCombinedATCChart()}
                    </div>
                </Aux>
            );
        } else {
            return (
                <aux>
                    {this.renderHeader()}
                    {this.renderMessage()}
                </aux>
            )
        }
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadCountries: () => dispatch(actions.loadCountries()),
        getStatisticsForCountry: (countryCode) => dispatch(actions.getStatisticsForCountry(countryCode)),
        getStatisticsForOpponentCountry: (countryCode) => dispatch(actions.getStatisticsForOpponentCountry(countryCode)),
        clearSelection: () => dispatch(actions.clearCountrySelection())
    }
};


const mapStateToProps = state => {
    return {
        countries: state.countries.countries,
        countryStatistics: state.countries.statistics,
        opponentCountryStatistics: state.countries.opponentCountryStatistics
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CompareCountries);
